var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layoutPage", [
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _c("main", { staticClass: "container card text-center" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_c("b", [_vm._v("Termos de Uso e Privacidade")])])
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "Para continuar, você precisa ler e aceitar nossos\n          "
            ),
            _c("a", { attrs: { href: _vm.getUrlTermo, target: "_blank" } }, [
              _vm._v("termos de uso")
            ]),
            _vm._v(" e\n          "),
            _c("a", { attrs: { href: _vm.getUrlPolitica, target: "_blank" } }, [
              _vm._v("aviso de privacidade")
            ]),
            _vm._v(".\n        ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-checkbox" },
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "checkbox",
                  model: {
                    value: _vm.aceito,
                    callback: function($$v) {
                      _vm.aceito = $$v
                    },
                    expression: "aceito"
                  }
                },
                [
                  _vm._v(
                    "\n            Declaro que li e estou ciente e de acordo com as normas\n            apresentadas.\n          "
                  )
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "button-acordo",
            attrs: { type: "success", disabled: !_vm.aceito },
            on: {
              click: function($event) {
                return _vm.aceitaTermos()
              }
            }
          },
          [_vm._v("\n        Li e estou de acordo\n      ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0feb758b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feb758b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/termos/termos.vue
// module id = null
// module chunks = 